module.exports = __webpack_public_path__ + "img/black-clock.060cb1ae.svg";